// extracted by mini-css-extract-plugin
export default {"_":"Avatar____N7kHg","smoothTranslate":"Avatar_smoothTranslate__lu+A4","head":"Avatar_head__dHUUK"};